import { generateNftMetadata } from './generate-nft-metadata.util';
import type { NFTMetadataInput, NFTOptions } from './nft.types';
import { translateMetadata } from './translate-nft-metadata.util';

export const buildNFTs = (
  options: NFTOptions,
  buildMetadataInput: (issueNumber: number) => NFTMetadataInput,
) =>
  Array<number>(options.count)
    .fill(options.startId)
    .map((n, i) => {
      const id = n + i;
      const issueNumber = i + 1;
      const metadataRaw = JSON.stringify(
        generateNftMetadata(options, buildMetadataInput(issueNumber)),
      )
        .split('{id}')
        .join(`${id}`)
        .split('{issueNumber}')
        .join(`${i + 1}`);
      return {
        id,
        label:
          options.count > 1 ? `${options.label}_${issueNumber}` : options.label,
        contractAddress: options.contractAddress,
        metadataRaw,
        metadata: translateMetadata(metadataRaw),
      };
    });
